// Clipboard Utilities - Reusable clipboard functionality
import { t } from '../../../i18n.js';

export class ClipboardUtils {
  
  // Copy text to clipboard with feedback
  async copyToClipboard(text, message) {
    const feedback = message || t('phone_copied', { text });
    try {
      await navigator.clipboard.writeText(text);
      this.showFeedback(feedback);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      // Fallback for older browsers
      this.fallbackCopyToClipboard(text, feedback);
    }
  }
  
  // Fallback copy method for older browsers
  fallbackCopyToClipboard(text, message) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.showFeedback(message || t('phone_copied', { text }));
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
    
    document.body.removeChild(textArea);
  }
  
  // Show temporary feedback message
  showFeedback(message, type = 'success') {
    const feedback = document.createElement('div');
    feedback.textContent = message;
    
    const backgroundColor = type === 'success' ? '#4CAF50' : '#f44336';
    
    feedback.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${backgroundColor};
      color: white;
      padding: 10px 15px;
      border-radius: 4px;
      z-index: 10000;
      font-size: 12px;
      font-family: 'Segoe UI', sans-serif;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    `;
    
    document.body.appendChild(feedback);
    
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.parentNode.removeChild(feedback);
      }
    }, 2000);
  }
}
